import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import FormWDP from "../Warehouse/TreasuryDocuments/FormWDP";
import { getDataWithComp, getAlert, getMaxWDPNo } from "../../../utils/SamuiUtils";

const BACK_URL = "/stock/stock-documents";

export default function StockFormCountPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const editWhDocId = searchParams.get("edit") ?? searchParams.get("view");
  const isViewMode = searchParams.has("view");
  const isEditMode = searchParams.has("edit");
  const isExistingDocMode = Boolean(editWhDocId);
  const backState = location.state ?? {};
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [maxDocNo, setMaxDocNo] = useState();
  useEffect(() => {
    localStorage.setItem("TreasuryDocumentsOrigin", BACK_URL);
    if (!isExistingDocMode) {
      loadMaxNo();
    } else {
      setMaxDocNo(undefined);
    }
  }, [isExistingDocMode]);

  const loadMaxNo = async () => {
    try {
      const rows = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '3' ORDER BY WHDoc_No DESC`
      );
      setMaxDocNo(getMaxWDPNo(rows, "CNT"));
    } catch (err) {
      getAlert("FAILED", err.message);
    }
  };

  const breadcrumbs = [
    { label: "สต๊อกสินค้า", link: "/stock/stock-overview" },
    { label: "เอกสารงานคลัง", link: BACK_URL },
    { label: isViewMode ? "ดูข้อมูลใบนับสต๊อก" : isEditMode ? "แก้ไขใบนับสต๊อก" : "สร้างใบนับสต๊อก" },
  ];

  return (
    <div className="WarehouseStock TreasuryDocuments">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#E13F57",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>
      <div className="wrapper">
        <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
        <div
          className={`main-panel ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          style={{ height: "100vh", overflow: "hidden" }}
        >
          <Topbar breadcrumbs={breadcrumbs} />
          <div className="container">
            <div className="page-inner" style={{ marginTop: "8px" }}>
              <FormWDP
                key={editWhDocId || "new"}
                callInitialize={() => navigate(BACK_URL, { state: backState })}
                mode="WDP"
                name="ใบนับสต๊อก"
                whDocNo={maxDocNo}
                docNoPrefix="CNT"
                editWhDocId={editWhDocId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
